import axiosClient from "../../../api/axiosClient";

// ======================================================
// GET SCHEDULE LIST
// ======================================================

async function getSchedules(params = {}) {

    const res = await axiosClient.get(
        "/api/wms/work-schedules",
        {
            params
        }
    );

    // Returns:
    // {
    //     data: [...],
    //     pagination: {...}
    // }

    return res.data.data;

}

// ======================================================
// GET SCHEDULE DETAILS
// ======================================================

async function getSchedule(scheduleId) {

    const res = await axiosClient.get(
        `/api/wms/work-schedules/${scheduleId}`
    );

    return res.data.data;

}

// ======================================================
// UPDATE SCHEDULE
// ======================================================

async function updateSchedule(
    scheduleId,
    payload
) {

    const res = await axiosClient.put(
        `/api/wms/work-schedules/${scheduleId}`,
        payload
    );

    return res.data.data;

}

// ======================================================
// PAUSE SCHEDULE
// ======================================================

async function pauseSchedule(
    scheduleId
) {

    const res = await axiosClient.put(
        `/api/wms/work-schedules/${scheduleId}/pause`
    );

    return res.data.data;

}

// ======================================================
// RESUME SCHEDULE
// ======================================================

async function resumeSchedule(
    scheduleId
) {

    const res = await axiosClient.put(
        `/api/wms/work-schedules/${scheduleId}/resume`
    );

    return res.data.data;

}

// ======================================================
// CANCEL SCHEDULE
// ======================================================

async function cancelSchedule(
    scheduleId
) {

    const res = await axiosClient.put(
        `/api/wms/work-schedules/${scheduleId}/cancel`
    );

    return res.data.data;

}

// ======================================================
// RUN SCHEDULER
// ======================================================

async function runScheduler() {

    const res = await axiosClient.post(
        "/api/wms/work-schedules/run"
    );

    return res.data.data;

}

// ======================================================
// EXECUTION HISTORY
// ======================================================

async function getExecutionHistory(
    scheduleId
) {

    const res = await axiosClient.get(
        `/api/wms/work-schedules/${scheduleId}/executions`
    );

    return res.data.data || [];

}

export default {

    getSchedules,

    getSchedule,

    updateSchedule,

    pauseSchedule,

    resumeSchedule,

    cancelSchedule,

    runScheduler,

    getExecutionHistory

};